export default __webpack_public_path__ + "static/media/delete-outline.4768f0ac.svg";